var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 16,
    fill: "#F4F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0748 25.0374C21.0699 23.6496 17.5236 19.9488 21.2244 17.1732C22.1718 16.4626 24.9252 15.7854 27.2382 18.0984C28.1199 18.9801 27.8257 19.8553 25.8504 21.3366C24.9604 22.0037 23.7224 23.0945 24.4626 24.5748C25.8504 22.5708 29.5512 19.0236 32.3268 22.7244C33.0374 23.6727 33.7146 26.4252 31.4016 28.7382C30.5199 29.6199 29.6447 29.3257 28.1634 27.3504C27.4963 26.4613 26.4055 25.2224 24.9252 25.9626C26.9301 27.3504 30.4764 31.0512 26.7756 33.8268C25.8273 34.5383 23.0748 35.2146 20.7618 32.9016C19.8801 32.0199 20.1743 31.1456 22.1496 29.6634C23.0387 28.9973 24.2776 27.9055 23.5374 26.4252C22.1496 28.4301 18.4488 31.9764 15.6732 28.2756C14.9626 27.3282 14.2854 24.5748 16.5984 22.2618C17.4801 21.3801 18.3553 21.6743 19.8366 23.6496C20.5037 24.5396 21.5945 25.7776 23.0748 25.0374Z",
    fill: "#00B1B2",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFan);
export default __webpack_public_path__ + "static/media/fan.578062ecf8fe4b290e4880c804306333.svg";
export { ForwardRef as ReactComponent };